module.exports = __webpack_public_path__ + "assets/filters-4a36a3.svg";